// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"665":"7573640c","799":"e33fcee4"}[chunkId] + ".chunk.js";
};